import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["withTimeScale"];
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { Box, xcss } from '@atlaskit/primitives';
import { DateRangeScale, getDateRangeScale } from '../../common/utils/utils';
import { DayPicker } from './day-picker';
import { messages } from './messages';
import { MonthPicker } from './month-picker';
import { QuarterPicker } from './quarter-picker';
var buttonGroupStyles = xcss({
  padding: 'space.250',
  display: 'grid',
  gap: 'space.050',
  gridTemplateColumns: 'repeat(3, 1fr)',
  justifyContent: 'center'
});
var datePickerContentWrapperStyles = xcss({
  width: '322px'
});
var DateRangePickerContent = function DateRangePickerContent(_ref) {
  var _ref$withTimeScale = _ref.withTimeScale,
    withTimeScale = _ref$withTimeScale === void 0 ? true : _ref$withTimeScale,
    props = _objectWithoutProperties(_ref, _excluded);
  var date = props.value;
  var initialScale = date ? getDateRangeScale(date) : DateRangeScale.MONTH;
  var _useState = useState(initialScale),
    _useState2 = _slicedToArray(_useState, 2),
    scale = _useState2[0],
    setScale = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onChange = useCallback(function (newDate) {
    if (newDate) {
      props.onChange(newDate, scale);
    }
  }, [props, scale]);
  var onScaleChange = useCallback(function (newScale) {
    setScale(newScale);
  }, []);
  var dateValue = date ? date.end : undefined;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: datePickerContentWrapperStyles
  }, /*#__PURE__*/React.createElement(Box, {
    testId: "date-picker-button-wrapper"
  }, scale && withTimeScale && /*#__PURE__*/React.createElement(Box, {
    xcss: buttonGroupStyles
  }, /*#__PURE__*/React.createElement(Button, {
    isSelected: scale === DateRangeScale.DAY,
    onClick: function onClick() {
      return onScaleChange(DateRangeScale.DAY);
    },
    testId: "day-picker-button"
  }, formatMessage(messages.dayPickerButtonMessage)), /*#__PURE__*/React.createElement(Button, {
    isSelected: scale === DateRangeScale.MONTH,
    onClick: function onClick() {
      return onScaleChange(DateRangeScale.MONTH);
    },
    testId: "month-picker-button"
  }, formatMessage(messages.monthPickerButtonMessage)), /*#__PURE__*/React.createElement(Button, {
    isSelected: scale === DateRangeScale.QUARTER,
    onClick: function onClick() {
      return onScaleChange(DateRangeScale.QUARTER);
    },
    testId: "quarter-picker-button"
  }, formatMessage(messages.quarterPickerButtonMessage)))), /*#__PURE__*/React.createElement(Box, {
    testId: "date-picker-content-wrapper"
  }, scale === DateRangeScale.DAY && /*#__PURE__*/React.createElement(DayPicker, {
    date: dateValue,
    onSelect: onChange
  }), scale === DateRangeScale.MONTH && /*#__PURE__*/React.createElement(MonthPicker, {
    date: dateValue,
    onSelect: onChange,
    withTimeScale: withTimeScale
  }), scale === DateRangeScale.QUARTER && /*#__PURE__*/React.createElement(QuarterPicker, {
    date: dateValue,
    onSelect: onChange
  })));
};
export default DateRangePickerContent;